




















































import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import DialogoDeEdicaoDeMotivosDeCancelamento from '@/components/venda/DialogoDeEdicaoDeMotivosDeCancelamento.vue';
import { MotivoCancelamento, Page, Pageable } from '@/models';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindMotivosDeCancelamentoUseCase } from '@/usecases/venda/FindMotivosDeCancelamentoUseCase';
import { CancelToken } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'

@Component({
	components: {
		DataTableDeCrudPaginado,
		DialogoDeEdicaoDeMotivosDeCancelamento,
	},
})

export default class TelaDeCadastrosDeMotivos extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicaoDeMotivosDeCancelamento!: DialogoDeEdicaoDeMotivosDeCancelamento

	findMotivosUseCase = new FindMotivosDeCancelamentoUseCase()
	busca = ''
	motivos: MotivoCancelamento[] = []
	carregando = false
	editando = false
	motivo: MotivoCancelamento | null = null

	headers = [
		{ text: 'Motivos', value: 'motivo' },
	]

	abrirDialogoDeEditarMotivo(indice: number) {
		try {
			if(!this.temRecurso('alterar', "motivos-de-cancelamento")) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			this.motivo = this.motivos[indice]

			this.dialogoDeEdicaoDeMotivosDeCancelamento.mostrar()
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeCriarMotivo() {
		try {
			if(!this.temRecurso('criar', 'motivos-de-cancelamento')) 
				throw new Error('Necessário permissão para criar')
			this.editando = true
			this.motivo = {
				id: '',
				motivo: '',
			} as MotivoCancelamento

			this.dialogoDeEdicaoDeMotivosDeCancelamento.mostrar()
		} catch(error) {
			AlertModule.setError(error)
		}
	}
	
	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<MotivoCancelamento>> {
		const pagina = await this.findMotivosUseCase.findAll({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.motivos = pagina.content
		return pagina
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	criarRegistro(motivo: MotivoCancelamento) {
		this.motivos.push(motivo)
	}

	atualizarRegistro(motivo: MotivoCancelamento) {
		const indice = this.motivos.findIndex( motivoExistente => motivoExistente.id === motivo.id)
		this.motivos.splice(indice, 1, motivo)
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

	@Watch('carregando')
	onChangeMostrar() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

}
